import React, { Component } from 'react';
import { ListGroupItem, ListGroup } from 'react-bootstrap';


export default class Resources extends Component {
    displayName = 'Resources';

    constructor(props) {
        super(props);

        this.state = {
            isSubmitting: false,
            showSavedMessage: false,
            showErrorMessage: false,
            id: '',
            agencyName: '',
            firstName: '',
            lastName: '',
            streetNumberName: '',
            unitType: '',
            unitNumber: '',
            city: '',
            state: '',
            zipCode: '',
            country: 'USA',
            phoneNumber: '',
            emailAddress: '',
            features: []
        }

        this.getAgencyInfo();
    }


    getAgencyInfo() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        fetch(`api/AgencyService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    id: data.id,
                    agencyName: data.name,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    streetNumberName: data.addresses[0].streetNumberName,
                    unitType: data.addresses[0].unitType,
                    unitNumber: data.addresses[0].unitNumber,
                    city: data.addresses[0].city,
                    state: data.addresses[0].state,
                    zipCode: data.addresses[0].zipCode,
                    country: data.addresses[0].country,
                    phoneNumber: data.phoneNumber,
                    emailAddress: data.emailAddress,
                    features: data.features
                })
            });
    }

    render() {
        return (
            <div>
                <h1>More Resources</h1>

                <ListGroup>
                    <ListGroupItem header="Release Notes">
                        Release notes represents the gradual improvements that have been made to ISM.
                        A new release release is an update or modification with the goal of providing better performance or fucntionality.
                        Be sure to check it out  <a href={process.env.REACT_APP_RELEASE_NOTES_LINK}
                            rel="noopener noreferrer" target="_blank">here</a>.
                    </ListGroupItem>
                    <ListGroupItem header="Greencardly">
                        Greencardly is a web app that tracks the times that USCIS is taking for different applications.
                        Using this web app you can estimate estimate the processing time of an application. This is based on publicly available data.

                        <a href="http://www.greencardly.com/"
                            rel="noopener noreferrer"
                            target="_blank">Greencardly - Processing Times </a>

                        <p>
                            <small>Note: Greencardly is in no way affiliated with ISM nor Hindsight Metrics.</small>
                        </p>
                    </ListGroupItem>
                </ListGroup>

                <p>
                    <a href={`mailto:${process.env.REACT_APP_CONTACT_US_EMAIL}?subject=Support%20${this.state.agencyName}`}
                        class="btn btn-primary">Email Support</a>
                </p>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/MoreResources/Resources.js